import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../Config/api.config";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { TbLoader2 } from "react-icons/tb";
import { FaServer, FaCheck } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import { GrServices } from "react-icons/gr";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";

const Services = () => {
  const [adminData] = useLocalStorage("adminData", "");
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState([]);
  const [totals, setTotals] = useState({
    totalEnabledServices: 0,
    totalOkServices: 0,
    totalErrorServices: 0,
  });

  const getServices = async () => {
    try {
      const res = await fetch(`${BASE_URL}adm.sys.services`, {
        headers: {
          Authorization: `Bearer ${adminData.uid}`,
        },
      });
      const data = await res.json();
      if (data?.status === "ok") {
        setServices(data.result.monitor || []);
        setTotals({
          totalEnabledServices: data.result.totalEnabledServices,
          totalOkServices: data.result.totalOkServices,
          totalErrorServices: data.result.totalErrorServices,
        });
      }
    } catch (err) {
      console.error("Error fetching services:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getServices();
  }, []);

  const renderStatusIcon = (status) => {
    if (status === "1") return <FaCheck className="text-green-500" />;
    if (status === "0") return <IoCloseSharp className="text-red-500" />;
    return null;
  };

  const UptimeBars = ({ lastResults }) => {
    const results = (lastResults || "").split(",").slice(-30); // últimos 30
    return (
      <div className="flex gap-0.5">
        {results.map((r, i) => (
          <Tooltip
            key={i}
            title={r === "200" ? "Success" : "Error"}
            placement="top"
          >
            <div
              className={`w-2 h-6 rounded-sm ${
                r === "200" ? "bg-green-500" : "bg-red-500"
              }`}
            />
          </Tooltip>
        ))}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="h-[20vh] flex items-center justify-center bg-white rounded-lg shadow">
        <TbLoader2 className="h-10 w-10 text-[#2563EB] animate-spin" />
      </div>
    );
  }

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex gap-4 items-center mb-6">
        <div className="p-3 bg-gradient-to-r from-[#2563EB] to-[#ed4685] rounded-lg shadow-lg">
          <FaServer className="h-6 w-6 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-gray-800">System Services</h1>
      </div>

      {/* Totals */}
      <div className="bg-white rounded-md mb-6 p-4 shadow flex items-center gap-6 text-gray-700">
        <p>
          <b>{totals.totalEnabledServices}</b> Enabled
        </p>
        <p>
          <b>{totals.totalOkServices}</b> OK
        </p>
        <p>
          <b>{totals.totalErrorServices}</b> Errors
        </p>
      </div>

      {/* Table */}
      {services.length > 0 ? (
        <TableContainer
          component={Paper}
          elevation={0}
          className="shadow rounded-lg"
        >
          <Table>
            <TableHead>
              <TableRow className="bg-gray-50">
                <TableCell className="font-semibold text-gray-700">
                  Status
                </TableCell>
                <TableCell className="font-semibold text-gray-700">
                  Service Name
                </TableCell>
                <TableCell className="font-semibold text-gray-700">
                  Last Run
                </TableCell>
                <TableCell className="font-semibold text-gray-700">
                  Result
                </TableCell>
                <TableCell className="font-semibold text-gray-700">
                  Details
                </TableCell>
                <TableCell className="font-semibold text-gray-700">
                  History
                </TableCell>
                <TableCell className="font-semibold text-gray-700">
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {services.map((srv, i) => (
                <TableRow
                  key={srv.service_id}
                  className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                >
                  <TableCell>{renderStatusIcon(srv.status)}</TableCell>
                  <TableCell>
                    <span className="font-medium text-gray-900">
                      {srv.name_service}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span className="text-sm text-gray-600">
                      {srv.last_run_date || "—"}
                    </span>
                  </TableCell>
                  <TableCell>
                    {srv.last_run_result_id === "200" ? (
                      <span className="inline-flex px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        Success
                      </span>
                    ) : (
                      <span className="inline-flex px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                        Error
                      </span>
                    )}
                  </TableCell>
                  <TableCell className="text-sm text-gray-600 truncate max-w-[200px]">
                    {srv.last_run_result_details || "—"}
                  </TableCell>
                  <TableCell>
                    <UptimeBars lastResults={srv.last_results} />
                  </TableCell>
                  <TableCell>
                    <button
                      className="inline-flex items-center gap-2 px-3 py-1 bg-[#2563EB] text-white rounded-lg hover:bg-[#1e4bbf] transition-colors text-sm shadow"
                      onClick={() =>
                        console.log("Run service:", srv.service_id)
                      }
                    >
                      <GrServices className="w-4 h-4" />
                      Run
                    </button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div className="p-4 text-center bg-white rounded shadow">
          <Typography>No services available</Typography>
        </div>
      )}
    </div>
  );
};

export default Services;
